// extracted by mini-css-extract-plugin
export var cardLayout = "_9b-1";
export var paginationContainer = "_9b-0";